import { BASE_URL, DELETE_FIELD_MASTER, FIELD_MASTER } from "../config";
import { getSessionId } from "../utils/SessionHandler";
import { handleResponse } from "./responseHandler";

export async function createFieldmaster(fieldData) {
  const response = await fetch(`${BASE_URL}${FIELD_MASTER}/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getSessionId()}`,
    },
    body: JSON.stringify(fieldData),
  });
  return handleResponse(response);
}

export async function fetchFieldMaster(query) {
  const response = await fetch(BASE_URL + FIELD_MASTER + query, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getSessionId()}`,
    },
  });

  return handleResponse(response);
}

export async function updateFieldmaster(fieldData, id) {
  const response = await fetch(`${BASE_URL}${FIELD_MASTER}/update/${id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getSessionId()}`,
    },
    body: JSON.stringify(fieldData),
  });

  return handleResponse(response);
}

export async function deleteFieldmaster(id) {
  const response = await fetch(`${BASE_URL}${DELETE_FIELD_MASTER}/${id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getSessionId()}`,
    },
  });

  return handleResponse(response);
}